import type { IBound } from '@blocksuite/global/utils';

import type { BubbleCollectionElementModel } from '../../element-model/collection-bubble.js';
import type { RoughCanvas } from '../../rough/canvas.js';
import type { Renderer } from '../renderer.js';
import { mindmap } from './mindmap.js';

export function collectionBubble(
  model: BubbleCollectionElementModel,
  ctx: CanvasRenderingContext2D,
  matrix: DOMMatrix,
  renderer: Renderer,
  rc: RoughCanvas,
  bound: IBound
) {
  mindmap(model, ctx, matrix, renderer, rc, bound);
}
